/* Installed Packages */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { GlobalErrorHandlerService } from './core/services';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

/* Imported Components */
import { LoadersModule } from '@ceslicensing/loaders';
import { ToastModule } from '@ceslicensing/toast-notification';
import { environment } from '@env/environment';
import { AuthModule } from '@auth0/auth0-angular';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    CommonModule,
    LoadersModule,
    HttpClientModule,
    ToastModule.forRoot({
      duration: 3500,
      style: 'default',
      position: 'top',
      wide: true,
    }),
    AuthModule.forRoot({
      domain: environment.auth.custom_domain,
      clientId: environment.auth.client_id,
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
      authorizationParams: {
        audience: environment.auth.audience,
        redirect_uri: `${window.location.origin}`,
        scope: 'openid profile email sso:admin_all',
      },
    }),
  ],
  providers: [GlobalErrorHandlerService],
  bootstrap: [AppComponent],
})
export class AppModule {}
